import { Role } from '@agilelab/plugin-wb-rbac-common';

export function adaptRole(form: {
  displayName: string;
  description?: string;
}): Role {
  const safeId = form.displayName
    .trim()
    .replace(/\s+/g, '_') // replace spaces with underscores
    .replace(/[^A-Z0-9_]/gi, '') // remove everything except letters, number
    .toUpperCase();

  return {
    id: safeId,
    displayName: form.displayName,
    description: form.description,
    visibility: 'user',
  } as Role;
}
